﻿import { CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { FilterGroupType } from '../../../../../types/filter-group';
import {
    UDViewDayNightShadingType,
    UDViewDayNightTwilightType,
    UDViewFilterGroupModel,
    UDViewMapStyle,
    UdViewModel,
    UDViewStaticDataSubLayerWithColor
} from '../../../../../udView/udview';

export const mapStyles = [
    { value: UDViewMapStyle.light, label: 'Light', image: '/img/map/Map-Light.png' },
    { value: UDViewMapStyle.dark, label: 'Dark', image: '/img/map/Map-Dark.png' },
    { value: UDViewMapStyle.darkReversed, label: 'Dark (reverse)', image: '/img/map/Map-DarkRev.png' },
    { value: UDViewMapStyle.blue, label: 'Blue', image: '/img/map/Map-Blue.png' },
    { value: UDViewMapStyle.classic, label: 'Classic', image: '/img/map/Map-Classic.png' },
    { value: UDViewMapStyle.streets, label: 'Streets', image: '/img/map/Map-Streets.png' },
    { value: UDViewMapStyle.satellite, label: 'Satellite', image: '/img/map/Map-Satellite.png' },
    { value: UDViewMapStyle.hybrid, label: 'Hybrid', image: '/img/map/Map-Hybrid.png' },
    { value: UDViewMapStyle.terrainStreets, label: 'Terrain Streets', image: '/img/map/Map-TerrainStreets.png' },
    { value: UDViewMapStyle.terrainSatellite, label: 'Terrain Satellite', image: '/img/map/Map-TerrainSatellite.png' }
];
export const projectionTypes = [
    { value: 'mercator', label: 'Mercator' },
    { value: 'globe', label: 'Globe' }
];
export const suaTypes = [
    { value: 'static', label: 'Static' },
    { value: 'dynamic', label: 'Dynamic' }
];
export const shadingTypes = [
    { value: UDViewDayNightShadingType.shade, text: 'Basic shading' },
    { value: UDViewDayNightShadingType.twilight, text: 'Advanced twilight shading' }
];
export const twilightTypes = [
    { value: UDViewDayNightTwilightType.sunrise, label: 'Sunrise/sunset' },
    { value: UDViewDayNightTwilightType.civil, label: 'Civil twilight' },
    { value: UDViewDayNightTwilightType.nautical, label: 'Nautical twilight' },
    { value: UDViewDayNightTwilightType.astronomical, label: 'Astronomical twilight' }
];

export enum LayersNavState {
    Layers,
    DayNightShadingSettings,
    TerrainShadingSettings,
    AircraftSettings,
    WeatherSettings,
    AirportSettings,
    FixesSettings,
    AirwaysSettings,
    SuaSettings,
    CustomGeojsonSettings,
    NavaidsSettings,
    OverwaterAreasSettings
}

export enum LayersAircraftNavState {
    aircraft,
    tags,
    iconsRings
}

export const navStateTitles: Record<LayersNavState, string> = {
    [LayersNavState.Layers]: 'Layers',
    [LayersNavState.DayNightShadingSettings]: 'Day/night shading',
    [LayersNavState.TerrainShadingSettings]: 'Terrain shading',
    [LayersNavState.AircraftSettings]: 'Aircraft Settings',
    [LayersNavState.FixesSettings]: 'Fixes Settings',
    [LayersNavState.AirwaysSettings]: 'Airways Settings',
    [LayersNavState.WeatherSettings]: 'Weather Settings',
    [LayersNavState.AirportSettings]: 'Airport Settings',
    [LayersNavState.SuaSettings]: 'SUA Settings',
    [LayersNavState.CustomGeojsonSettings]: 'Custom Geojson Settings',
    [LayersNavState.NavaidsSettings]: 'Navaids Settings',
    [LayersNavState.OverwaterAreasSettings]: 'Overwater Areas Settings'
};

export type LayerConfigDefaultColor = Array<{ type: 'literal'; color: string } | { type: 'maplibre-global-state'; value: string }>;

export type LayerFieldConfig = {
    value: boolean | UDViewStaticDataSubLayerWithColor;
    label: string;
    spacingBefore?: boolean;
    setChecked: (value: boolean) => void;
    setColor?: (value: string | null) => void;
    defaultColor?: LayerConfigDefaultColor;
    fields?: LayerFieldConfig[];
};

export interface LayerConfig {
    label: string;
    value: boolean;
    onChange: (e: CheckboxChangeEvent) => void;
    defaultColor?: LayerConfigDefaultColor;
    fields?: LayerFieldConfig[];
    filterGroups?: {
        /** Controls whether there should be a color selection for filter groups */
        colored?: boolean;
        get: (view: UdViewModel) => UDViewFilterGroupModel;
        type: FilterGroupType;
    };
    navigateTo?: LayersNavState;
}
